module.exports = __webpack_public_path__ + "static/media/game(7).d44b0865.PNG";